import { borderRadii } from './borderRadii';
import { borders } from './borders';
import { colors } from './colors';
import { fonts } from './fonts';
import { images } from './images';
import { margins } from '../allThemes/margins';
import { paddings } from '../allThemes/paddings';
import { zIndexes } from '../allThemes/zIndexes';
import { breakpoints } from '../allThemes/breakpoints';
import { buttons } from './buttons';
const zeefiTheme = {
  colors,
  fonts,
  margins,
  paddings,
  borderRadii,
  borders,
  images,
  buttons,
  zIndexes,
  breakpoints
};

export { zeefiTheme };
